export default __webpack_public_path__ + "static/media/mini-7.605c4b5c.jpg";